import { VulnerabilityPackageDetails } from './vulnerability-package-details';

export interface VulnerabilityPackagesDetailsResult {
  repositoriesVulnerabilityPackagesDetails: VulnerabilityPackageDetails[];
}
